/* eslint-disable camelcase */
import { EmmaFactory } from "@axa-asia/hk-emma-js";
import { maskPN } from "@axa-asia/hk-emma-web-module/lib/ga-lib/MaskingUtil";
import { getScreenNameAsync } from "@axa-asia/hk-emma-web-module/lib/ga-lib/WebScreenNameMappingUtil";
import config from "../config";
import { gaScreenNameMapping } from "../constants/gaScreenNameMapping";
import { getPlatformStr } from "../utils/GaPreviousScreenUtil";
/**
 * Translate screen path to screen name
 */
const getScreenName = async (screenPath) => {
  const platformStr = getPlatformStr();
  const screenNameMapping = gaScreenNameMapping;
  const screenName = await getScreenNameAsync(
    screenPath,
    platformStr,
    screenNameMapping
  );
  return screenName;
};

/**
 * Track default page view
 * GA4 - KPI #0
 */
export const trackDefaultPageViewGA4 = (
  curr_screen_name,
  previous_screen_name,
  curr_screen_path
) => {
  if (config.isApp) {
    const spa_curr_screen_name = maskPN(
      `SPA:${curr_screen_name}`.replace(/(\/)$/, "")
    );
    const spa_previous_screen_name = maskPN(
      `SPA:${previous_screen_name}`.replace(/(\/)$/, "")
    );
    const spa_curr_screen_path = maskPN(
      `SPA:${curr_screen_path}`.replace(/(\/)$/, "")
    );

    EmmaFactory.createInstance().then((e) => {
      e.instance.trackScreen(
        spa_curr_screen_name,
        spa_previous_screen_name,
        spa_curr_screen_path
      );
    });
  }
};

/**
 * GA4 - KPI #1
 */
export const trackCreateAccount = () => {
  if (config.isApp) {
    EmmaFactory.createInstance().then((e) => {
      e.instance.trackEvent("create_account", {});
    });
  }
};

/**
 * GA4 KPI #5
 * @param {*} policy_fail_message
 */
export const trackAddPolicyFailed = (policy_fail_message) => {
  if (config.isApp) {
    EmmaFactory.createInstance().then((e) => {
      e.instance.trackEvent("add_policy_failure", {
        policy_fail_message,
      });
    });
  }
};

/**
 * GA4 KPI #6 - Track add policy submission on review page
 * @param {*} verification_type
 */
export const trackAddPolicy = (verification_type) => {
  if (config.isApp) {
    EmmaFactory.createInstance().then((e) => {
      e.instance.trackEvent("verify_policy", {
        verification_type,
      });
    });
  }
};

/**
 * GA4 KPI #7 - Track forget username or password submission on review page
 * @param {*} verification_type
 */
export const trackForgetUsernamePassword = (verification_type) => {
  if (config.isApp) {
    EmmaFactory.createInstance().then((e) => {
      e.instance.trackEvent("reset_account", {
        verification_type,
      });
    });
  }
};

/**
 * GA KPI #62
 * @param {*} displayed_button_text
 * @param {*} screen_name
 */
export const trackCtaButton = (displayed_button_text, bare_screen_path) => {
  if (config.isApp) {
    const screen_path = maskPN(bare_screen_path);
    getScreenName(screen_path).then((screen_name) => {
      EmmaFactory.createInstance().then((e) => {
        e.instance.trackEvent("click_cta_button", {
          displayed_button_text,
          screen_path,
          screen_name,
        });
      });
    });
  }
};
